var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-input-group",
        { staticClass: "flex-nowrap" },
        [
          _c(
            "b-button",
            {
              staticClass:
                "flex-grow-1 flex-shrink-1 d-flex justify-content-between align-items-center bg-white text-dark border shadow-none",
              staticStyle: { "min-width": "100px" },
              attrs: {
                id: "dropdown-trigger-" + _vm._uid,
                disabled: _vm.isDisabled,
                variant: "outline-secondary",
                size: "sm"
              }
            },
            [
              _c("span", { staticClass: "text-truncate mr-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.item ? _vm.item.name : "Не выбрано") +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("font-awesome-icon", {
                staticClass: "text-muted",
                attrs: { icon: "chevron-down", size: "xs" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              ref: "popoverSearch",
              attrs: {
                target: "dropdown-trigger-" + _vm._uid,
                triggers: "focus",
                tabindex: "-1",
                placement: "bottom",
                container: "body"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "py-2 px-3",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      size: "sm",
                      autocomplete: "off",
                      placeholder: "Поиск..."
                    },
                    model: {
                      value: _vm.query,
                      callback: function($$v) {
                        _vm.query = $$v
                      },
                      expression: "query"
                    }
                  }),
                  _vm._v(" "),
                  _vm.items.length === 0
                    ? _c("div", { staticClass: "text-muted text-small mt-1" }, [
                        _vm._v("\n          Ничего не найдено\n        ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "scrollable-dropdown-content" },
                [
                  _c(
                    "b-list-group",
                    {
                      attrs: { flush: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                        }
                      }
                    },
                    _vm._l(_vm.items, function(option) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: option.id,
                          staticClass:
                            "d-flex align-items-center justify-content-between py-2 px-1",
                          attrs: { button: "", action: "" },
                          on: {
                            click: function($event) {
                              return _vm.onClick(option)
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c("span", {
                              staticClass: "d-inline-block rounded-circle mr-2",
                              style: {
                                backgroundColor: option.color || "#ced4da",
                                width: "10px",
                                height: "10px",
                                flexShrink: 0
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(option.name))])
                          ]),
                          _vm._v(" "),
                          _vm.item && _vm.item.id === option.id
                            ? _c("font-awesome-icon", {
                                attrs: { icon: "check" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            { staticClass: "flex-shrink-0" },
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", disabled: _vm.isDisabled },
                  on: { click: _vm.onClear }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times-circle" } })],
                1
              ),
              _vm._v(" "),
              _vm.canCreateCatalog()
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.v-success",
                          modifiers: { hover: true, "v-success": true }
                        }
                      ],
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.isDisabled,
                        title: "Создать справочник"
                      },
                      on: { click: _vm.showModalCatalog }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "plus" } })],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalVisible
        ? _vm._t("create-catalog", null, {
            exactId: 0,
            refresh: _vm.onCatalogCreated
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d8e8aa0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8e8aa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/CatalogSelect.vue
// module id = null
// module chunks = 